import React from 'react';
import { connect } from 'react-redux';

import EventManagerComponent from '../../components/app/Events/eventManager/EventManager';

import * as actions from '../../actions/events/eventManager';

const EventManager = (props) => {
  return (
    <EventManagerComponent {...props} />
  );
};

export default connect(({ event, user }) => ({ eventManager: event.eventManager, user }), actions)(EventManager);
